"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "valdaone": {
    "721324bc": [{
      "hkey": "a29e1640",
      "slug": "valdaone",
      "name": "Valdaone",
      "primary": true,
      "skipSearch": false
    }],
    "bedoe": [{
      "hkey": "a29e1640",
      "slug": "valdaone",
      "name": "Valdaone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "183482a0": [{
      "hkey": "a29e1640",
      "slug": "valdaone",
      "name": "Valdaone",
      "primary": true,
      "skipSearch": false
    }],
    "cherio": [{
      "hkey": "a29e1640",
      "slug": "valdaone",
      "name": "Valdaone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c016a327": [{
      "hkey": "a29e1640",
      "slug": "valdaone",
      "name": "Valdaone",
      "primary": true,
      "skipSearch": false
    }],
    "crona": [{
      "hkey": "a29e1640",
      "slug": "valdaone",
      "name": "Valdaone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e65d301a": [{
      "hkey": "a29e1640",
      "slug": "valdaone",
      "name": "Valdaone",
      "primary": true,
      "skipSearch": false
    }],
    "forca": [{
      "hkey": "a29e1640",
      "slug": "valdaone",
      "name": "Valdaone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9efe39c9": [{
      "hkey": "a29e1640",
      "slug": "valdaone",
      "name": "Valdaone",
      "primary": true,
      "skipSearch": false
    }],
    "formino": [{
      "hkey": "a29e1640",
      "slug": "valdaone",
      "name": "Valdaone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5af676ed": [{
      "hkey": "a29e1640",
      "slug": "valdaone",
      "name": "Valdaone",
      "primary": true,
      "skipSearch": false
    }],
    "garda": [{
      "hkey": "a29e1640",
      "slug": "valdaone",
      "name": "Valdaone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ae3af186": [{
      "hkey": "a29e1640",
      "slug": "valdaone",
      "name": "Valdaone",
      "primary": true,
      "skipSearch": false
    }],
    "gardone-corno": [{
      "hkey": "a29e1640",
      "slug": "valdaone",
      "name": "Valdaone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "382827be": [{
      "hkey": "a29e1640",
      "slug": "valdaone",
      "name": "Valdaone",
      "primary": true,
      "skipSearch": false
    }],
    "ghinova": [{
      "hkey": "a29e1640",
      "slug": "valdaone",
      "name": "Valdaone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "589453df": [{
      "hkey": "a29e1640",
      "slug": "valdaone",
      "name": "Valdaone",
      "primary": true,
      "skipSearch": false
    }],
    "greggi": [{
      "hkey": "a29e1640",
      "slug": "valdaone",
      "name": "Valdaone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "579cac2b": [{
      "hkey": "a29e1640",
      "slug": "valdaone",
      "name": "Valdaone",
      "primary": true,
      "skipSearch": false
    }],
    "merlino": [{
      "hkey": "a29e1640",
      "slug": "valdaone",
      "name": "Valdaone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a93cf674": [{
      "hkey": "a29e1640",
      "slug": "valdaone",
      "name": "Valdaone",
      "primary": true,
      "skipSearch": false
    }],
    "moia": [{
      "hkey": "a29e1640",
      "slug": "valdaone",
      "name": "Valdaone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3911bde3": [{
      "hkey": "a29e1640",
      "slug": "valdaone",
      "name": "Valdaone",
      "primary": true,
      "skipSearch": false
    }],
    "nosguil": [{
      "hkey": "a29e1640",
      "slug": "valdaone",
      "name": "Valdaone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4efd7923": [{
      "hkey": "a29e1640",
      "slug": "valdaone",
      "name": "Valdaone",
      "primary": true,
      "skipSearch": false
    }],
    "pasture": [{
      "hkey": "a29e1640",
      "slug": "valdaone",
      "name": "Valdaone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1cf5ed1b": [{
      "hkey": "a29e1640",
      "slug": "valdaone",
      "name": "Valdaone",
      "primary": true,
      "skipSearch": false
    }],
    "peschera": [{
      "hkey": "a29e1640",
      "slug": "valdaone",
      "name": "Valdaone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3eb673a5": [{
      "hkey": "a29e1640",
      "slug": "valdaone",
      "name": "Valdaone",
      "primary": true,
      "skipSearch": false
    }],
    "piolino": [{
      "hkey": "a29e1640",
      "slug": "valdaone",
      "name": "Valdaone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7a86fa96": [{
      "hkey": "c8a769e9",
      "slug": "pracul-limes-vermongoi",
      "name": "Pracul-Limes-Vermongoi",
      "primary": true,
      "skipSearch": false
    }],
    "varmongoi": [{
      "hkey": "c8a769e9",
      "slug": "pracul-limes-vermongoi",
      "name": "Pracul-Limes-Vermongoi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;